import { createFileRoute } from '@tanstack/react-router';
import { Box } from '@mui/material';
import { AuditDocumentRequestType } from '@ata-digital/client-tax-system-api-client';
import { QueryErrorBoundary } from '@/components/query/QueryErrorBoundary';
import { BinderDetail } from '@/features/audit-binders/detail/BinderDetail';

type FilterMode = 'all' | 'needs-me' | 'open';
type SortMode = 'priority' | 'due' | 'created';
type TabKey = 'requests' | 'documents' | 'comments' | 'signatures' | 'non-client-uploads';

interface BinderSearch {
  item?: string;
  view?: TabKey;
  filter?: FilterMode;
  sort?: SortMode;
  requestType?: AuditDocumentRequestType;
  /** Deep-link from a notification: open the signing dialog for this document. */
  sign?: string;
}

const requestTypeValues = Object.values(AuditDocumentRequestType) as string[];

export const Route = createFileRoute('/preparer/audit-binders/$binderId')({
  validateSearch: (search): BinderSearch => ({
    item: typeof search.item === 'string' ? search.item : undefined,
    view:
      search.view === 'documents' ||
      search.view === 'comments' ||
      search.view === 'signatures' ||
      search.view === 'non-client-uploads'
        ? search.view
        : undefined,
    filter:
      search.filter === 'all' || search.filter === 'open' || search.filter === 'needs-me' ? search.filter : undefined,
    sort: search.sort === 'due' || search.sort === 'created' ? search.sort : undefined,
    requestType:
      typeof search.requestType === 'string' && requestTypeValues.includes(search.requestType)
        ? (search.requestType as AuditDocumentRequestType)
        : undefined,
    sign: typeof search.sign === 'string' ? search.sign : undefined,
  }),
  errorComponent: QueryErrorBoundary,
  component: StaffAuditBinderDetailPage,
});

function StaffAuditBinderDetailPage() {
  const { binderId } = Route.useParams();
  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <BinderDetail binderId={binderId} />
    </Box>
  );
}
